module.exports = __webpack_public_path__ + "img/collectTiringIcon.9a301010.png";